import type {UIMSceneEnum} from '../../../../../../../shared/enums/UIMSceneEnums.ts'
import {UIModeSelectorDetailsController, type StartGameCallback, type SelectModeCallback} from '../../../../../../shared/scripts/ui_html/home_page/UIModeSelectorDetailsController.ts'
import {type UIMSceneController} from '../../../UIMSceneController.ts'

export class UIMModeSelectorDetailsController extends UIModeSelectorDetailsController {
    private readonly sceneController: UIMSceneController
    private previousScene: UIMSceneEnum | undefined

    constructor(onStartGame: StartGameCallback, onSelectMode: SelectModeCallback, sceneController: UIMSceneController) {
        super(onStartGame, onSelectMode)
        this.sceneController = sceneController
        this.detailsContainer.classList.add('mm-details-mobile')
    }

    protected onShow() {
        this.previousScene = this.sceneController.scene
        this.sceneController.loadScene(undefined)
    }

    protected onHide() {
        const previousScene = this.previousScene
        this.hideAndClearPreviousScene()
        this.sceneController.loadScene(previousScene)
    }

    hideAndClearPreviousScene() {
        this.previousScene = undefined
        this.detailsContainer.classList.add('hidden')
    }
}
